import { AppState } from 'src/config/appState';

import { getCPProgramState } from '../../selectors/cpProgramSelectors';
import { CorePillarsRating } from '../models/weekShared';

export const getCorePillarsRating = (state: AppState): CorePillarsRating =>
    getCPProgramState(state).corePillarsRating;
